import { ReactComponent as AppleMusicOriginalIcon } from 'resources/img/svg/appleMusicOriginal.svg';

import { IconmoonFont } from 'vibo-ui/Icon';
import { MusicExportSource } from 'types/enums';

export const SOURCES_DATA = {
  [MusicExportSource.spotify]: {
    icon: IconmoonFont['spotifyColorful-24'],
    text: 'exportToSpotify',
  },
  [MusicExportSource.appleMusic]: {
    icon: AppleMusicOriginalIcon,
    text: 'Export to Apple Music',
  },
  [MusicExportSource.beatsource]: {
    icon: IconmoonFont['beatsourceColorful-24'],
    text: 'exportToBeatsource',
  },
};
